import { useContext } from "react";
import { store } from "./Store";

export const useStore = () => {
  const { state, dispatch } = useContext(store);
  return { state, dispatch };
};
